<template>
  <Modal :open="open" @close="$emit('close')" size="medium">
    <SaturdayChallengeContent :active="open" />
  </Modal>
</template>

<script>
import { Modal } from "@estaly/ui";
import SaturdayChallengeContent from "./SaturdayChallengeContent.vue";

export default {
  components: {
    Modal,
    SaturdayChallengeContent,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
};
</script>
